import { Button } from "@sfc/ui";
import { Link } from "wouter";

export function OpenFundingOpportunities({
  applications,
}: {
  applications: { roundId: string; roundName: string }[];
}) {
  if (applications.length === 0) return null;
  return (
    <section
      aria-label="Open funding opportunities"
      className="divide-y divide-primary/10 rounded-lg border border-primary/15 bg-primary/5"
    >
      {applications.length < 3 ? (
        applications.map((application) => (
          <div
            key={application.roundId}
            className="flex flex-col items-start justify-between gap-4 px-6 py-5 sm:flex-row sm:items-center"
          >
            <div className="min-w-0 space-y-1">
              <h2 className="heading-md [overflow-wrap:anywhere]">
                {application.roundName}
              </h2>
              <p className="body-sm text-primary">Applications are open</p>
            </div>
            <Button
              nativeButton={false}
              variant="nav"
              className="shrink-0 bg-primary px-4 text-primary-foreground hover:bg-primary/90"
              render={
                <Link
                  href={`/apply/${encodeURIComponent(application.roundId)}`}
                />
              }
            >
              Preview Application →
            </Button>
          </div>
        ))
      ) : (
        <div className="flex flex-col items-start justify-between gap-4 px-6 py-5 sm:flex-row sm:items-center">
          <div className="space-y-1">
            <h2 className="heading-md">Find Funding for Your Team</h2>
            <p className="body-sm text-primary">
              {applications.length} funding rounds are open
            </p>
          </div>
          <Button
            nativeButton={false}
            variant="nav"
            className="shrink-0 bg-primary px-4 text-primary-foreground hover:bg-primary/90"
            render={<Link href="/apply" />}
          >
            Explore Funding Rounds →
          </Button>
        </div>
      )}
    </section>
  );
}
